import {
  ExtractDocumentInputsMutationMutationCgResponse,
  ExtractDocumentInputsMutationMutationVariables,
} from '@common/graphql';
import { gql, TypedDocumentNode } from '@common/hooks';

export const EXTRACT_DOCUMENT_INPUTS_MUTATION: TypedDocumentNode<
  ExtractDocumentInputsMutationMutationCgResponse,
  ExtractDocumentInputsMutationMutationVariables
> = gql`
  mutation ExtractDocumentInputsMutation(
    $documentUrl: String
    $documentFiles: [FileUploadInput!]
    $documentType: DocumentType!
    $worksListId: ID!
  ) {
    extractDocumentInputs(
      documentUrl: $documentUrl
      documentFiles: $documentFiles
      documentType: $documentType
      worksListId: $worksListId
    ) {
      aiTraceId
      extractedInputs {
        inputName
        inputValue
      }
    }
  }
`;
